// extracted by mini-css-extract-plugin
export default {"name":"Nav_name__MiIWb","center":"Nav_center__Bg7Y7","title":"Nav_title__2Fj0i"};